import { DissectedError } from '../DissectedError'
import { HandledApplicationError } from '../HandledApplicationError'

export const serializeError = (error: HandledApplicationError | DissectedError) => {
    if (error instanceof HandledApplicationError) {
        return new Error(JSON.stringify({ ...error }))
    }
    if (error instanceof DissectedError) {
        return new Error(JSON.stringify({ ...error }))
    }
    return error
}
